<template>
  <div>
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <Cart></Cart>
  </div>
</template>

<script>
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import Cart from '@/components/front/Cart';
import { mapActions } from 'vuex';
export default {
  created() {
    this.setCartLength();
  },
  components: { Header, Footer, Cart },
  methods: {
    ...mapActions(['setCartLength']),
  },
};
</script>
